// Subentity round-trip reconciliation extracted from the subentityDidCancel and
// subentityDidReturnValueValue computeds of
// components/defaultLayout/EntityDialog&Forms/EntityDialog.vue. When a top-level
// dialog opens a subentity dialog to create a related record, the child reports
// back via the store's `subentityReturnValue`: 'CANCELLED', null (nothing yet),
// or the created value. These pure predicates decode that signal for the parent.
// Pulled into a tested module for the Nuxt 2 -> Nuxt 3 / Vuex -> Pinia migration;
// the component now forwards to these. Inline console.debug noise is dropped.

// The subentity dialog was cancelled — only meaningful for the parent (a
// subentity dialog does not itself consume this).
export function subentityDidCancel(opts: {
  subentityReturnValue: any
  isSubentityDialog: boolean
}): boolean {
  return opts.subentityReturnValue === 'CANCELLED' && !opts.isSubentityDialog
}

// The value a subentity dialog returned to its parent, or undefined when there
// is nothing to apply: a cancellation, no return yet (null), or when this is the
// subentity dialog itself.
export function resolveSubentityReturnValue(opts: {
  subentityReturnValue: any
  isSubentityDialog: boolean
}): any {
  const { subentityReturnValue, isSubentityDialog } = opts
  const shouldReturnValue =
    subentityReturnValue !== 'CANCELLED' &&
    subentityReturnValue !== null &&
    !isSubentityDialog
  if (!shouldReturnValue) {
    return undefined
  }
  return subentityReturnValue
}
